import React, { useState } from 'react';
import { BuildingLogItem } from './BuildingLog';
import { formatDate } from '../../../common/utils/Date/Date';
import LogsGroup from './LogsGroup';

export interface ChangeGroupProps {
  date: string;
  logs: BuildingLogItem[];
}

export const ChangeGroup: React.FC<ChangeGroupProps> = ({ date, logs }) => {
  const count = logs.length;
  const countText = count === 1
    ? 'Byla nalezena 1 změna'
    : count > 1 && count < 5
      ? `Byly nalezeny ${count} změny`
      : `Bylo nalezeno ${count} změn`;

  const [isExpanded, setIsExpanded] = useState(true);

  const handleToggle = () => {
    setIsExpanded(prev => !prev);
  };

  return (
    <LogsGroup
      title={formatDate(new Date(date))}
      subtitle={countText}
      logs={logs}
      isExpanded={isExpanded}
      onToggle={handleToggle}
      headerClassName="BuildingLogsGroup__header BuildingLogsGroup__header--change"
    />
  );
};

export default ChangeGroup;
